enum EHotkeysMap {
	enter = 'Enter',
	esc = 'Escape'
}

export { EHotkeysMap };
